'use client'

import { useEffect } from 'react'
import { useRouter } from '~/hooks/use-localized-navigation.hook'

import { useAuth } from '~/providers/auth-provider'

export const HomeRedirect = () => {
	const router = useRouter()
	const { isLoading, isAuth } = useAuth()

	useEffect(() => {
		if (isAuth && !isLoading) {
			router.push('/dashboard')
		}
	}, [isAuth, isLoading, router])

	return null
}
